import { Grid, makeStyles } from '@material-ui/core';
import * as React from 'react';

import { TableColors } from '../../../core/config/mainTheme';
import { border } from '../../../core/utils/theme.utils';

export interface TableGridContainerProps {
  children?: React.ReactNode;
}

const TableGridContainer = React.forwardRef<HTMLDivElement, TableGridContainerProps>(
  ({ children }, ref) => {
    const classes = useStyles();

    return (
      <Grid
        ref={ref}
        className={`${classes.gridContainer} ag-theme-alpine`}
        data-cy="search-results"
      >
        {children}
      </Grid>
    );
  },
);

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    borderRadius: 0,
    color: theme.palette.secondary.main,
    borderLeft: border(theme.palette.divider),
    borderRight: border(theme.palette.divider),
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    overflow: 'hidden',

    '& .table-toolbar': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.background.paper,
    },
    '& .ag-root-wrapper': {
      borderRadius: 0,
      border: 'solid 0px',
    },
    '& .ag-root-wrapper-body': {
      position: 'relative',
      top: 'auto',
      '& .ag-layout-normal': { minHeight: '40px', clear: 'both', position: 'relative' },
    },
    '& .ag-header-cell-label .ag-header-cell-text': {
      whiteSpace: 'normal',
    },
    '& .ag-header': {
      backgroundColor: theme.palette.secondary.main,
      borderBottomColor: TableColors.rowBorderColor,
      color: theme.palette.secondary.main,
    },
    '& .ag-header-row, .ag-row, .ag-header-row': {
      color: theme.palette.secondary.dark,
    },
    '& .ag-row-hover': {
      backgroundColor: theme.palette.secondary.main,
    },
    '& .ag-stub-cell': {
      paddingTop: 14,
      '.ag-loading-text': {
        marginTop: 0,
      },
    },
    '& .ag-checkbox-input-wrapper.ag-checked::after': {
      color: theme.palette.primary.main,
    },
    '& .ag-row-selected': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.contrastText,
      '& a': {
        color: theme.palette.primary.contrastText,
      },
    },
    '& .ag-react-container': {
      width: '100%',
    },
    '& .ag-column-select-column-readonly': {
      display: 'none',
    },
    '& .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell), .ag-pinned-left-header': {
      borderRightColor: TableColors.rowBorderColor,
    },
    '& .ag-cell': {
      '&.borderedRight': {
        borderRight: `1px solid ${theme.palette.divider}`,
      },
    },
    '& .ag-side-bar': {
      color: theme.palette.secondary.dark,
      '& .ag-side-buttons': {
        width: 'auto',
        paddingTop: 0,
      },
    },
    '& .ag-overlay-wrapper': {
      padding: theme.spacing(5),
    },
    '& .ag-column-panel': {
      flexDirection: 'inherit', //style for show all columns on sidebar
    },
    '& .multipleLineCell': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 'normal',
      whiteSpace: 'break-spaces',
    },
  },
}));

export default TableGridContainer;
